module.exports = __webpack_public_path__ + "img/red-stop-lamp-off.663312f7.svg";